var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"waiting text-center"},[_c('h1',[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }